import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
//import { IoChevronBack } from 'react-icons/io5';
//import TopNav from '../components/TopNav';
import { useNoobookContext } from '../context/NoobookContext';
import { getAccessToken, getNativeWebview } from '../react-queries/queries';
import { processApiResponse, ERROR_CODES } from '../common/errorMessage';
import { getBookevent, getBookeventApplicant, applyToBookevent, cancelToBookevent, putMissiondoneLinks, deleteBookevent } from '../api/BookeventApi';
import { BookEventType, NoobookRole } from '../common/enums';
import LoadingOverlay from '../components/LoadingOverlay';
import MoimRecruitPage from './MoimRecruitPage';
import { FaTimes } from 'react-icons/fa';
import { useUserInfoQuery } from '../react-queries/queries';

import MissionDoneLinkInput from '../components/MissionDoneLinkInput';
import ReviewMoimApplicantPage from './ReviewMoimApplicantPage';
import ReviewMoimMissiondoneLinkPage from './ReviewMoimMissiondoneLinkPage';
import MessageModal from '../components/MessageModal';
import { launchUrl } from '../api/native/NativeApis';
import BookCoverImage from '../components/BookCoverImage';




const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;



const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;


const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;



const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;






const Wrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;
`;

const Content = styled.div`
  padding: 0 0 32px 0;
`;

const BannerImg = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 0;
`;

const ProfileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 20px 0 20px;
`;

const ProfileImg = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #eaeaea;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #bbb;
`;

const ProfileInfo = styled.div`
  flex: 1;
  padding-left: 0;
`;

const ProfileInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
`;

const Nickname = styled.div`
  font-weight: bold;
  font-size: 1.1rem;
  color: #222;
`;

const UserId = styled.div`
  color: #888;
  font-size: 0.95rem;
`;

const Badge = styled.span`
  background: #e64980;
  color: #fff;
  font-size: 13px;
  border-radius: 4px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
  margin-left: 4px;
`;

const TagRow = styled.div`
  color: #888;
  font-size: 0.85rem;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-left: 0;
  margin-top: 0;
`;

const BookDescHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 24px 20px 8px 20px;
`;

const BookDescTitle = styled.div`
  font-size: 1.1rem;
`;

const EditButton = styled.button`
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background: #1565c0;
  }
`;

const HeaderButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const AddressButton = styled(EditButton)`
  background: #546e7a;

  &:hover {
    background: #455a64;
  }
`;

const DeleteButton = styled(EditButton)`
  background: #e64980;

  &:hover {
    background: #d6336c;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const UrlModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9000;
`;

const UrlModalContent = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const UrlModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
`;

const UrlModalTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  color: #333;
`;

const UrlModalBody = styled.div`
  padding: 24px;
`;

const UrlText = styled.div`
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  word-break: break-all;
  background: #f5f5f7;
  border-radius: 8px;
  padding: 12px;
`;

const UrlModalButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
`;

const UrlModalButton = styled.button`
  padding: 12px 24px;
  background: ${({ secondary }) => (secondary ? '#e0e0e0' : '#244AC2')};
  color: ${({ secondary }) => (secondary ? '#333' : '#fff')};
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  
  &:hover {
    opacity: 0.9;
  }
`;

const ProfileRequiredMessage = styled.div`
  font-size: 15px;
  color: #333;
  line-height: 1.6;
  text-align: center;
  white-space: pre-line;
`;

const ProfileRequiredButton = styled.button`
  padding: 12px 24px;
  background: ${({ secondary }) => (secondary ? '#9e9e9e' : '#244AC2')};
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    opacity: 0.9;
  }
`;

const EditModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const EditModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const EditModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const EditModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const BookDesc = styled.div`
  color: #222;
  font-size: 1rem;
  margin: 0 20px;
  white-space: pre-line;
`;

const MoreDetail = styled.div`
  display: flex;
  align-items: center;
  color: ${({ $disabled }) => ($disabled ? '#ccc' : '#888')};
  font-size: 0.85rem;
  margin: 6px 20px 0 20px;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  gap: 4px;
  user-select: none;
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
`;

const BookInfoRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 24px 20px 0 20px;
`;

const BookInfo = styled.div`
  flex: 1;
`;

const BookTitle = styled.div`
  font-size: 1.0rem;
  margin-bottom: 4px;
`;

const BookAuthor = styled.div`
  color: #888;
  font-size: 0.92rem;
  margin-bottom: 2px;
`;

const InfoTable = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: 4px;
  column-gap: 10px;
  margin-top: 8px;
  align-items: center;
  font-size: 0.9rem;
`;

const InfoLabelBadge = styled.span`
  background: ${({ gray }) => (gray ? '#666' : '#1976d2')};
  color: #fff;
  font-size: 0.9rem;
  border-radius: 4px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
`;

const ApplyButton = styled.button`
  display: block;
  width: 50%;
  margin: 40px auto 0 auto;
  margin-bottom: 40px;
  background: #244AC2;
  color: #fff;
  font-size: 18px;
  border: none;
  border-radius: 24px;
  padding: 14px 0;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(36,74,194,0.08);
  transition: background 0.15s;
  font-weight: 500;
  &:active {
    background: #193a99;
  }
`;

// 지원 현황 관련 styled components 추가
const ApplicantStatusSection = styled.div`
  margin: 20px 24px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
`;

const StatusTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin: 0 0 16px 0;
`;

const StatusContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const StatusText = styled.div`
  font-size: 14px;
  color: #333;
  text-align: center;
  padding: 8px 0;
`;

const StatusButton = styled.button`
  padding: 12px 24px;
  background: #007AFF;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background: #0056CC;
  }
  
  &.secondary {
    background: #6c757d;
    
    &:hover {
      background: #5a6268;
    }
  }
  
  &.danger {
    background: #dc3545;
    
    &:hover {
      background: #c82333;
    }
  }
`;

const MissionLinkList = styled.div`
  margin-top: 12px;
`;

const MissionLinkItem = styled.div`
  padding: 12px;
  background: white;
  border-radius: 8px;
  margin-bottom: 8px;
  border: 1px solid #e9ecef;
`;

const MissionLinkTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #222;
  margin-bottom: 4px;
`;

const MissionLinkUrl = styled.div`
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  word-break: break-all;
`;

const MissionLinkDate = styled.div`
  font-size: 12px;
  color: #999;
`;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ReviewMoimDetailPage({bookEventId, onDeleted = null}) {
  const navigate = useNavigate();
  const query = useQuery();
  if(!bookEventId) {
    bookEventId = query.get('bookEventId');
  }
  const { setShowBack, setLogoText } = useNoobookContext();
  const {data: userInfo} = useUserInfoQuery();
  
  const [bookEvent, setBookEvent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [missionTypes, setMissionTypes] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [myApplicantInfo, setMyApplicantInfo] = useState(null);
  const [msgModalTitle, setMsgModalTitle] = useState('');

  // 지원자 목록 모달 관련 상태 추가
  const [showApplicantModal, setShowApplicantModal] = useState(false);

  const [showMissiondoneModal, setShowMissiondoneModal] = useState(false);

  // 에러 모달 관련 상태 추가
  const [showMsgModal, setShowMsgModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const [showUrlModal, setShowUrlModal] = useState(false);
  const [showProfileRequiredModal, setShowProfileRequiredModal] = useState(false);
  const isAdmin = userInfo?.userRole === NoobookRole.ADMIN;
  const pageUrl = `/review-moim-detail?bookEventId=${bookEventId}`;

  useEffect(() => {
    setShowBack(true);
    setLogoText('');
    loadData();
    return () => setShowBack(false);
  }, [bookEventId]);



  // 에러 모달 표시 함수
  const showError = (message) => {
    setMsgModalTitle('오류');
    setAlertMessage(message);
    setShowMsgModal(true);
  };

  const showAlert = (message) => {
    setMsgModalTitle('알림');
    setAlertMessage(message);
    setShowMsgModal(true);
  };

  // 에러 모달 닫기 함수
  const closeMsgModal = () => {
    setShowMsgModal(false);
    setAlertMessage('');
  };


  const loadData = async () => {
    if(loading) {
      return;
    }
    setLoading(true);
    try {
      await loadBookEvent(false);
      await loadMyBookEventApplicant(false);
    } catch (error) {
      showError('Error loading book event and applicant info:', error);
    } finally {
      setLoading(false);
    }
  }

  // 북이벤트 정보 로드
  const loadBookEvent = async (needLoading) => {
    if (!bookEventId || (needLoading && loading)) return;
    if(needLoading) {
      setLoading(true);
    }
    //setError('');
    
    try {
      const { accessToken } = await getAccessToken();
      const response = await getBookevent(accessToken || '', parseInt(bookEventId));
      const processedResponse = processApiResponse(response);  
      if (processedResponse.success) {
        setBookEvent(processedResponse.data);
        if (processedResponse.data && processedResponse.data.missiondoneTypes) {
          setMissionTypes(processedResponse.data.missiondoneTypes);
        }
      } else {
        const errorMsg = processedResponse.message || '북이벤트 정보를 불러오는데 실패했습니다.';
        //setError(errorMsg);
        showError(errorMsg);
      }
    } catch (error) {
      console.error('북이벤트 로드 중 오류:', error);
      const errorMsg = '네트워크 오류가 발생했습니다. 다시 시도해 주세요.';
      //setError(errorMsg);
      showError(errorMsg);
    } finally {
      if(needLoading) {
        setLoading(false);
      }
    }
  };

  // 내 북이벤트 신청자 정보 로드 함수
  const loadMyBookEventApplicant = async (needLoading) => {
    if (!bookEventId) return;
    if(needLoading) {
      if(loading) {
        return;
      }
      setLoading(true);
    }
    try {
      const {accessToken} = await getAccessToken();
      const response = await getBookeventApplicant(accessToken || '', bookEventId);
      const processedResponse = processApiResponse(response);
      console.log('myApplicantInfo', response.errorCode);
      
      if (processedResponse.success) {
        setMyApplicantInfo(processedResponse.data);
      } else if(response.errorCode === ERROR_CODES.NOTFOUND) {
        setMyApplicantInfo(null);
      } else {
        // 에러가 있지만 1000408이 아닌 경우 (신청하지 않은 경우가 아닌 실제 에러)
        const errorMsg = processedResponse.message || '신청자 정보를 불러오는데 실패했습니다.';
        showError(errorMsg);
      }
    } catch (error) {
      console.error('Error loading my book event applicant info:', error);
      const errorMsg = '신청자 정보를 불러오는데 실패했습니다.';
      showError(errorMsg);
    } finally {
      if(needLoading) {
        setLoading(false);
      }
    }
  };

  // 수정 모달 열기
  const openEditModal = () => {
    setShowEditModal(true);
  };

  const openUrlModal = () => {
    setShowUrlModal(true);
  };

  const closeUrlModal = () => {
    setShowUrlModal(false);
  };

  const handleCopyPageUrl = async () => {
    try {
      await navigator.clipboard.writeText(pageUrl);
      setMsgModalTitle('알림');
      setAlertMessage('주소가 클립보드에 복사되었습니다.');
      setShowMsgModal(true);
    } catch (error) {
      console.error('클립보드 복사 실패:', error);
      try {
        const textArea = document.createElement('textarea');
        textArea.value = pageUrl;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        setMsgModalTitle('알림');
        setAlertMessage('주소가 클립보드에 복사되었습니다.');
        setShowMsgModal(true);
      } catch (fallbackError) {
        console.error('Fallback 클립보드 복사 실패:', fallbackError);
        setMsgModalTitle('오류');
        setAlertMessage('클립보드 복사에 실패했습니다.');
        setShowMsgModal(true);
      }
    }
  };

  // 수정 모달 닫기
  const closeEditModal = (modified) => {
    setShowEditModal(false);
    if (modified) {
      loadBookEvent(true);
    }
  };

  const handleDeleteClick = async () => {
    if (!bookEventId) {
      showError('북이벤트 ID가 없습니다.');
      return;
    }
    if (!window.confirm('정말로 이 북이벤트를 삭제하시겠습니까?\n삭제된 이벤트는 복구할 수 없습니다.')) {
      return;
    }
    if (loading) {
      return;
    }

    try {
      setLoading(true);
      const { accessToken } = await getAccessToken();
      const response = await deleteBookevent(accessToken || '', parseInt(bookEventId, 10));
      const processedResponse = processApiResponse(response);

      if (processedResponse.success) {
        if(onDeleted) {
          onDeleted();
        }
      } else {
        showError(processedResponse.errorMessage || '북이벤트 삭제에 실패했습니다.');
      }
    } catch (err) {
      console.error('북이벤트 삭제 중 오류:', err);
      showError('북이벤트 삭제에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const openApplicantModal = () => {
    setShowApplicantModal(true);
  }

  const closeApplicantModal = () => {
    setShowApplicantModal(false);
  }

  // 활동내역 모달 관련 함수들
  const openMissiondoneModal = () => {
    setShowMissiondoneModal(true);
  }

  const closeMissiondoneModal = () => {
    setShowMissiondoneModal(false);
  }

  // 신청하기 버튼 클릭 핸들러
  const handleApplyClick = async() => {
    if(loading) {
      return;
    }

    const handphoneNum = userInfo?.handphoneNum?.trim();
    const mailingAddr = userInfo?.mailingAddr?.trim();
    if (!handphoneNum || !mailingAddr) {
      setShowProfileRequiredModal(true);
      return;
    }

    setLoading(true);
    try {
      const {accessToken} = await getAccessToken();
      const response = await applyToBookevent(accessToken || '', bookEventId);
      const processedResponse = processApiResponse(response);
      if(processedResponse.success) {
        loadMyBookEventApplicant(true);
      } else if(response.errorCode === ERROR_CODES.EXPIRED) {
        showError('신청 기간이 만료 되었거나 아직 신청 가능한 기간이 아닙니다.');
      } else {
        showError(processedResponse.errorMessage || '신청에 실패했습니다.');
      }
    } catch (error) {
      console.error('Error applying to book event:', error);
      showError('신청에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const closeProfileRequiredModal = () => {
    setShowProfileRequiredModal(false);
  };

  const goToSettingsForProfile = () => {
    setShowProfileRequiredModal(false);
    navigate('/settings');
  };

  const handleDetailsLinkClick = () => {
    const link = bookEvent?.detailsLinkUrl?.trim();
    if (!link) return;

    // 앱 내부 상대 경로
    if (link.startsWith('/') && !link.startsWith('//')) {
      navigate(link);
      return;
    }

    try {
      const url = new URL(link, window.location.origin);
      if (url.origin === window.location.origin) {
        navigate(`${url.pathname}${url.search}${url.hash}`);
        return;
      }
      // 외부 URL: 절대 URL(href)로 전달해야 네이티브 Linking 이 정상 동작
      if (getNativeWebview()) {
        launchUrl(url.href);
      } else {
        window.open(url.href, '_blank', 'noopener,noreferrer');
      }
    } catch (e) {
      console.error('자세히보기 링크 이동 실패:', e);
      if (getNativeWebview()) {
        launchUrl(link);
      } else {
        window.open(link, '_blank', 'noopener,noreferrer');
      }
    }
  };

  // 신청하기 버튼 클릭 핸들러
  const handleCancelApplyClick = async() => {
    if(loading) {
      return;
    }
    setLoading(true);
    try {
      const {accessToken} = await getAccessToken();
      const response = await cancelToBookevent(accessToken || '', bookEventId);
      const processedResponse = processApiResponse(response);
      if(processedResponse.success) {
        loadMyBookEventApplicant(true);
      } else {
        showError(processedResponse.errorMessage || '신청에 실패했습니다.');
      } 
    } catch (error) {
      console.error('Error canceling apply to book event:', error);
      showError('신청취소에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  // 링크 제출 모달 닫기
  const closeLinkModal = () => {
    setShowLinkModal(false);
  };

  // 링크 저장 핸들러 수정
  const handleLinkSave = async (linkData) => {
    if (loading) {
      return;
    }
    
    setLoading(true);
    try {
      const {accessToken} = await getAccessToken();
      
      // linkData에 bookeventId와 userId 추가
      const missiondoneLinks = linkData.map(link => ({
        ...link,
        bookeventId: bookEventId,
        userId: userInfo?.id
      }));
      
      const response = await putMissiondoneLinks(accessToken || '', bookEventId, missiondoneLinks);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        setShowLinkModal(false);
        showAlert('활동내역이 저장되었습니다.');
        // 신청자 정보 새로고침
        loadMyBookEventApplicant(false);
      } else {
        showError(processedResponse.message || '활동내역 저장에 실패했습니다.');
      }
    } catch (error) {
      console.error('Error saving link data:', error);
      showError('활동내역 저장에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };
      

  // 로딩 중이거나 에러가 있으면 처리
  if (loading) {
    return (
      <Wrapper>
        <LoadingOverlay />
      </Wrapper>
    );
  }

  

  if (!bookEvent) {
    return (
      <Wrapper>
        <Content>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            padding: '20px',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '16px',
              color: '#666',
              marginBottom: '30px',
              lineHeight: '1.5'
            }}>
              북이벤트 정보를 찾을 수 없습니다.
            </div>
          </div>
        </Content>
      </Wrapper>
    );
  }

  // 날짜 포맷팅 함수
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', { timeZone: 'Asia/Seoul' });
  };

  // isRecruiter 확인 함수
  const isRecruiter = bookEvent && userInfo && bookEvent.recruiter.id === userInfo.id;

  // 지원 현황 UI 렌더링 함수
  const renderApplicantStatus = () => {
    if (isRecruiter) {
      // 모집자인 경우
      return (
        <ApplicantStatusSection>
          
          <StatusContent>
            <StatusButton onClick={openApplicantModal}>
              지원자 보기
            </StatusButton>
          
            <StatusButton onClick={openMissiondoneModal}>
              활동 현황 보기
            </StatusButton>
          </StatusContent>
        </ApplicantStatusSection>
      );
    } else {
      // 신청자인 경우
      if (!myApplicantInfo) {
        // 신청하지 않은 경우
        return (
          <ApplicantStatusSection>
            <StatusTitle>지원 현황</StatusTitle>
            <StatusContent>
              <StatusButton onClick={handleApplyClick}>
                {bookEvent?.eventType === BookEventType.RECRUIT_REVIEWER ? '서평단 신청하기' : '필사단 신청하기'}
              </StatusButton>
            </StatusContent>
          </ApplicantStatusSection>
        );
      } else {
        // 신청한 경우
        const { accepted, missiondoneLinks } = myApplicantInfo;
        
        switch (accepted) {
          case 'APPLY':
            return (
              <ApplicantStatusSection>
                <StatusTitle>지원 현황</StatusTitle>
                <StatusContent>
                  <StatusText>신청중인 상태입니다</StatusText>
                  <StatusButton className="danger" onClick={handleCancelApplyClick}>
                    신청취소
                  </StatusButton>
                </StatusContent>
              </ApplicantStatusSection>
            );
            
          case 'ACCEPTED':
            return (
              <ApplicantStatusSection>
                <StatusTitle>지원 현황</StatusTitle>
                  <StatusContent>
                    <StatusText>선정되었습니다.</StatusText>
                  </StatusContent>
                  <StatusTitle>활동내역</StatusTitle>
                    <StatusContent>
                  {missiondoneLinks && missiondoneLinks.length > 0 ? (
                    <>
                      <MissionLinkList>
                        {missiondoneLinks.map((link, index) => (
                          <MissionLinkItem key={index}>
                            <MissionLinkTitle>{link.missiondoneType?.typeName || '활동내역'}</MissionLinkTitle>
                            <MissionLinkUrl>{link.linkUrl}</MissionLinkUrl>
                            <MissionLinkDate>{link.missiondoneAt ? new Date(link.missiondoneAt).toLocaleDateString() : '-'}</MissionLinkDate>
                          </MissionLinkItem>
                        ))}
                      </MissionLinkList>
                      <StatusButton onClick={() => setShowLinkModal(true)}>
                        활동내역 수정
                      </StatusButton>
                    </>
                  ) : (
                    <StatusButton onClick={() => setShowLinkModal(true)}>
                      활동내역 등록
                    </StatusButton>
                  )}
                 </StatusContent>
              </ApplicantStatusSection>
            );
            
          case 'REJECTED':
            return (
              <ApplicantStatusSection>
                <StatusTitle>지원 현황</StatusTitle>
                <StatusContent>
                  <StatusText>선정되지 못 했습니다.</StatusText>
                </StatusContent>
              </ApplicantStatusSection>
            );
            
          case 'CANCEL':
            return (
              <ApplicantStatusSection>
                <StatusTitle>지원 현황</StatusTitle>
                <StatusContent>
                  <StatusText>취소 하였습니다.</StatusText>
                  <StatusButton onClick={handleApplyClick}>
                    {bookEvent?.eventType === BookEventType.RECRUIT_REVIEWER ? '서평단 신청하기' : '필사단 신청하기'}
                  </StatusButton>
                </StatusContent>
              </ApplicantStatusSection>
            );
            
          default:
            return null;
        }
      }
    }
  };


  return (
    <Wrapper>
      <Content>
        <BannerImg src={bookEvent.imgUrl || '/book_sample.jpg'} alt="banner" />
        <ProfileRow>
          <ProfileImg>
            {bookEvent?.recruiter?.profileImgUrl ? (
              <img src={bookEvent?.recruiter?.profileImgUrl} alt="profile" style={{width:'100%',height:'100%',borderRadius:'50%'}}/>
            ) : (
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="16" r="16" fill="#e0e0e0"/>
                <path d="M16 16c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-3.33 0-10 1.667-10 5v2h20v-2c0-3.333-6.67-5-10-5z" fill="#bbb"/>
              </svg>
            )}
          </ProfileImg>
          <ProfileInfo>
            <ProfileInfoRow>
              <Nickname>{bookEvent?.recruiter?.name}</Nickname>
              <UserId>{bookEvent?.recruiter?.loginid}</UserId>
              <Badge>모집자</Badge>
            </ProfileInfoRow>
            <TagRow>
              {bookEvent.hashtags && bookEvent.hashtags.length > 0 
                ? bookEvent.hashtags.map(tag => <span key={tag}>#{tag}</span>)
                : <span></span>
              }
            </TagRow>
          </ProfileInfo>
        </ProfileRow>
        
        <BookDescHeader>
        <BookDescTitle>이벤트 소개</BookDescTitle>
          {(isRecruiter || isAdmin) && (
            <HeaderButtonGroup>
              {isRecruiter && (
                <EditButton onClick={openEditModal}>
                  수정
                </EditButton>
              )}
              {(isRecruiter || isAdmin) && (
              <DeleteButton onClick={handleDeleteClick} disabled={loading}>
                삭제
              </DeleteButton>
              )}
              {isAdmin && (
                <AddressButton onClick={openUrlModal}>
                  주소확인
                </AddressButton>
              )}
            </HeaderButtonGroup>
          )}
        </BookDescHeader>
        <BookDesc>{bookEvent.briefIntroduction || '이벤트 소개가 없습니다.'}</BookDesc>
        <MoreDetail
          $disabled={!bookEvent?.detailsLinkUrl?.trim()}
          onClick={handleDetailsLinkClick}
        >
          <span style={{fontSize:'0.9em', display:'flex', alignItems:'center'}}>▶</span>
          <span>자세히보기</span>
        </MoreDetail>
        <BookInfoRow>
          {bookEvent?.books?.length > 0 && (
            <BookCoverImage
              src={bookEvent.books[0]?.cover}
              alt={bookEvent.books[0]?.title}
              width={90}
              height={130}
              boxShadow="none"
              fontSize={11}
            />
          )}
          <BookInfo>
            <BookTitle>{bookEvent?.books?.[0]?.title}</BookTitle>
            <BookAuthor>{bookEvent?.books?.[0]?.author || '저자 정보 없음'}</BookAuthor>
            <InfoTable>
              <InfoLabelBadge>모집기간</InfoLabelBadge>
              <div>
                {formatDate(bookEvent.recruitFr)} ~ {formatDate(bookEvent.recruitTo)}
              </div>
              <InfoLabelBadge>모집인원</InfoLabelBadge>
              <div>{bookEvent.recruitNum || 0}명</div>
              <InfoLabelBadge gray>활동 기한</InfoLabelBadge>
              <div>{formatDate(bookEvent.missionCompletedAt) || '-'}</div>
            </InfoTable>
          </BookInfo>
        </BookInfoRow>
        <BookDescHeader>
          <BookDescTitle>필수 활동</BookDescTitle>
        </BookDescHeader>
        <BookDesc>{bookEvent?.mission || '필수 활동이 없습니다.'}</BookDesc>
        {/*
        <ApplyButton onClick={handleApplyClick}>
          {bookEvent.eventType === BookEventType.RECRUIT_REVIEWER ? '서평단 신청하기' : '필사단 신청하기'}
        </ApplyButton>
        */}
      

      {/* BookInfoRow 아래에 지원 현황 정보 추가 */}
      {renderApplicantStatus()}

      </Content>
      
      {/* 수정 모달 */}
      {showEditModal && (
        <EditModal>
          <EditModalHeader>
            <EditModalTitle>북이벤트 수정</EditModalTitle>
            <CloseButton onClick={closeEditModal}>
              <FaTimes />
            </CloseButton>
          </EditModalHeader>
          <EditModalContent>
            <MoimRecruitPage editBookEventId={bookEventId} onClose={closeEditModal} />
          </EditModalContent>
        </EditModal>
      )}

      {/* 링크 제출 모달 */}
      {showLinkModal && (
        <MissionDoneLinkInput
          missionTypes={missionTypes}
          missiondoneLinks={myApplicantInfo?.missiondoneLinks?.map(link=>{
            return {
              missiondoneTypeId: link.missiondoneType.id,
              linkUrl: link.linkUrl
            }
          })}
          onSave={handleLinkSave}
          onClose={closeLinkModal}
        />
      )}

      {/* 지원자 목록 모달 */}
      {showApplicantModal && (
        <ReviewMoimApplicantPage
          bookEventId={bookEventId}
          onClose={closeApplicantModal}
        />
      )}

      {/* 활동내역 모달 */}
      {showMissiondoneModal && (
        <Modal>
          <ModalHeader>
            <ModalTitle>활동내역 현황</ModalTitle>
            <CloseButton onClick={closeMissiondoneModal}>
              <FaTimes />
            </CloseButton>
          </ModalHeader>
          <ModalContent>
            <ReviewMoimMissiondoneLinkPage bookEventId={bookEventId} />
          </ModalContent>
        </Modal>
      )}

      {/* 주소확인 모달 */}
      {showUrlModal && (
        <UrlModalOverlay onClick={closeUrlModal}>
          <UrlModalContent onClick={(e) => e.stopPropagation()}>
            <UrlModalHeader>
              <UrlModalTitle>주소확인</UrlModalTitle>
              <CloseButton onClick={closeUrlModal}>
                <FaTimes />
              </CloseButton>
            </UrlModalHeader>
            <UrlModalBody>
              <UrlText>{pageUrl}</UrlText>
              <UrlModalButtonRow>
                <UrlModalButton secondary onClick={closeUrlModal}>닫기</UrlModalButton>
                <UrlModalButton onClick={handleCopyPageUrl}>복사</UrlModalButton>
              </UrlModalButtonRow>
            </UrlModalBody>
          </UrlModalContent>
        </UrlModalOverlay>
      )}

      {/* 주소/핸드폰 미등록 안내 모달 */}
      {showProfileRequiredModal && (
        <UrlModalOverlay onClick={closeProfileRequiredModal}>
          <UrlModalContent onClick={(e) => e.stopPropagation()}>
            <UrlModalHeader>
              <UrlModalTitle>알림</UrlModalTitle>
              <CloseButton onClick={closeProfileRequiredModal}>
                <FaTimes />
              </CloseButton>
            </UrlModalHeader>
            <UrlModalBody>
              <ProfileRequiredMessage>
                {'등록된 주소와 핸드폰 번호가 없습니다.\n내정보>설정에서 정보 입력 후 신청해 주세요'}
              </ProfileRequiredMessage>
              <UrlModalButtonRow>
                <ProfileRequiredButton onClick={goToSettingsForProfile}>정보등록</ProfileRequiredButton>
                <ProfileRequiredButton secondary onClick={closeProfileRequiredModal}>취소</ProfileRequiredButton>
              </UrlModalButtonRow>
            </UrlModalBody>
          </UrlModalContent>
        </UrlModalOverlay>
      )}

      {/* 에러 모달 */}
      <MessageModal
        isOpen={showMsgModal}
        message={alertMessage}
        onClose={closeMsgModal}
        title={msgModalTitle}
      />
    </Wrapper>
  );
} 
